import React from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'

import SEO from '../../components/seo'
import Navbar from '../../components/navbar_poc'
import AboutTwo from '../../components/about-two'
import CtaOne from '../../components/cta/cta-one'
import Partner from '../../components/partner'
import PricingTwo from '../../components/pricing-two'
import Footer from '../../components/footer'
import AboutThree from '../../components/about-three'
import phoneImg from '../../assets/images/startup/whyindia2.jpg'
import ClientThree from '../../components/client-three'
import heroImg from '../../assets/images/startup/homehero2.png'
import { lawyerServices} from '../../data/data'
import { featureData, skillData, teamData } from '../../data/poc'
import ClientLogoSlider from '../../components/ClientLogoSlider'
import aboutImg2 from '../../assets/images/education/rootsandtree.png'

import image1 from '../../assets/images/portfolio/customermap.png'
import image2 from '../../assets/images/portfolio/single02.jpg'
import image3 from '../../assets/images/portfolio/single03.jpg'
import bg1 from '../../assets/images/managment/whywestarted.jpg'
import { portfolioData, social } from '../../data/portfolio'
import VideoModalTwo from '../../components/video-modal-two'
import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';

import cta from '../../assets/images/cta.jpg'
import bg2 from '../../assets/images/b2blogobasic.png'
import bg3 from '../../assets/images/finance/bg3.jpg'

import { financefeature } from '../../data/data'

const images = [bg1, bg2, bg3];
export default function IndexPoc() {

    const {currentIndex,navigate} = useNavigate();

    const handleSubmit = (e) => {
      e.preventDefault(); // prevent default form submission behavior
      navigate('/contact'); // redirect to /contact
    };
    let Images = [image1]
    const settings = {
        container: '.tiny-single-item',
            items: 1,
            controls: false,
            mouseDrag: true,
            loop: false,
            rewind: true,
            autoplay: false,
            autoplayButtonOutput: false,
            autoplayTimeout: 3000,
            navPosition: "bottom",
            speed: 400,
            gutter: 16,
      };
      let params = useParams();
      let id = params.id;
      let data = portfolioData.find((item)=>item.id === parseInt(id))
  return (
    <>
     <Navbar/> 
     <SEO
  title="Pioneer One Global – Expand & Thrive in India with Confidence"
  description="Global thinking meets local expertise. Pioneer One Global helps businesses explore, enter, and grow in India with smart compliance and cultural fluency."
  url="https://www.pioneeroneglobal.com"
  image="https://www.pioneeroneglobal.com/images/og-home.jpg"
/>
    <section className="bg-home zoom-image d-flex align-items-center">
      <div className="bg-overlay image-wrap" id="home" style={{backgroundImage:`url(${bg2})`, backgroundPosition:'center'}}> </div>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row justify-content-center mt-5">
              <div className="col-12">
                  <div className="title-heading text-center">
                      <h4 className="display-4 fw-bold text-white title-dark">Bridge to Bharath <br/> - Your India Entry Playbook</h4>
                      <p className="para-desc mx-auto text-white">A practical podcast guide for global businesses to evaluate, enter, and scale in India.</p>
                      <div className="mt-4 pt-2">
                      <Link to="/bridgetobharath" className="btn btn-primary m-1">Podcast</Link>
                          {/* <Link to="/bridge" className="btn btn-secondary m-1">Download Executive Summary</Link> */}

                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
<section className="bg-half-170 bg-light">
      <div className="container">
          <div className="container">
              <div className="row justity-content-center mt-5">
                  <div className="col-12">
                      <div className="title-heading text-center">
                          <h4 className="heading fw-bold mb-3">Helping Global Businesses <br/>Grow with India</h4>
                          <p className="para-desc mx-auto text-muted">Pioneer One Global is your trusted partner for market exploratin, entry, compliance, and sustainable growth.</p>
                      </div>
                  </div>
                  {/* <div className="col-12 mt-md-5 mx-auto">
                      <img src={bg1} className="img-fluid shadow rounded-5" alt=""/>
                      <VideoModalTwo/>
                  </div> */}
              </div>
          </div>
      </div>
    </section>
 


    <section className="section">
         <div className="container mt-4">
          <div className="row align-items-center">
              <div className="col-md-6">
                  <img src={phoneImg} className="img-fluid" alt=""/>
              </div>

              <div className="col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title">
                      <h4 className="title mb-4">Why India? <br/><span className="text-primary">Why now?</span></h4>
                      <p className="text-muted para-desc"></p>
                      <ul className="list-inline mb-0">
                      <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> World's fastest-growing major economy, 1.4B consumers, digital-first governance</li>
                      <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Strategic Location: A key player in the global China+1 strategy</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Generous government incentives through the Production-Linked Incentive (PLI) schemes across multiple sectors</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Competitive labor and land costs for both services and manufacturing industries</li>
                      </ul>
                      <div className="mt-4">
                          <Link to="page-why-india" className="text-primary">Learn More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      </section>
      <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">How We Help</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Whether you're just beginning to consider India, ready to set up operations, or already present and facing challenges — we’ve designed tailored paths to meet you where you are.</p>
                      <p>Choose the option that best describes your current stage, and see how we can help you move forward with confidence.</p>
                  </div>
              </div>
          </div>

                   <div className="row">
                      {lawyerServices.map((item,index)=>{
                        let Icon = item.icon
                        return(
                          <div className="col-md-4 col-12 mt-4 pt-2" key={index}>
                              <div className="card border-0 shadow rounded-3 text-center p-4 py-4">
                                  <div className="content">
                                      <Icon className={item.color}></Icon>
                                      <h4 className="title mt-3">{item.title}</h4>
                                      <p className="text-muted">{item.desc}</p>
                                <Link to={item.linkto} className="text-dark">Know More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                                       
                                  </div>
                              </div>
                          </div>
                        )
                      })}
                      </div>

          {/* <div className="row">
            {featureData.map((item,index)=>{
              return(
                <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                    <div className="feature p-3 py-4 rounded">
                        <i className={`mdi mdi-layers-triple-outline text-primary float-start me-3 mt-2 mdi-36px ${item.icon}`}></i>
                        <div className="content d-block overflow-hidden">
                            <h4 className="title">{item.title}</h4>
                            <p className="text-muted mt-2">{item.desc}</p>
                            <Link to="#" className="text-dark">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                        </div>
                    </div>
                </div>
              )
            })}
          </div> */}
      </div>
    </section>
    <section className="section">
    <div className="container">
    <div className="container mt-4">
          <div className="row align-items-center">
              <div className="col-md-5 order-1 order-md-2 text-end">
                  <img src={aboutImg2} className="img-fluid shadow-lg rounded-top-pill rounded-bottom-5" alt=""/>
              </div>

              <div className="col-md-7 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title">
                      <h4 className="title mb-4">Rooted in Wisdom.<br/> Built to Scale.</h4>
                      <p className="text-muted">India offers more than a market. It offers a mindset.</p>
                      <p className="text-muted">At Pioneer One Global, we help companies grow with India — not just through strategy and execution, but by grounding that growth in India's deeper strengths: its values, its culture, and its spirit of resilience.</p>
                      <p className="text-muted">We believe long-term success comes from strong roots. India’s civilizational wisdom, its emphasis on ethics, adaptability, and community, offers global businesses a way to scale sustainably — with purpose, not just profit.</p>
                      <p className="text-muted">Our approach blends operational clarity with cultural intelligence. We guide our clients not only through incorporation, compliance, and execution — but through India’s way of thinking, leading, and building relationships.</p>
                      <p className="text-muted"><b>Grow with India — in spirit as well as in strategy.</b></p>
                      <div className="mt-4">
                          <Link to="#" className="btn btn-outline-primary">Schedule a Free Consult</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  {/* <ClientLogoSlider/> */}
  </div>
  </section>
    <section className="section">
    <div className="container">
    <div className="row">
                      <div className="col-12 text-center">
                          <div className="section-title mb-4 pb-2">
                              <h4 className="title mb-4">Our Global Presence</h4>
                              <p className="text-muted para-desc mx-auto mb-0">Each star marks a country where our customers are making an impact — a testament to our growing global reach and trusted partnerships across continents. </p>
                          </div>
                      </div>
                  </div>
        {data?.image ? 
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <img src={data?.image} alt="" className="img-fluid w-100"/>
                </div>
            </div> 
              :
            <div className="row">
                <div className="col-12">
                  <div className="tiny-single-item">  
                    <TinySlider settings={settings}>
                        {Images.map((item,index)=>{
                            return(
                                <div className="tiny-slide" key={index}>
                                    <img src={item} className="d-block w-100 rounded shadow" alt=""/>
                                </div>
                            )
                        })}
                    </TinySlider>
                  </div>
                </div>
            </div> 
        }
      </div>
              <div className="container mt-4">
                  <div className="row">
                      <div className="col-12 text-center">
                          <div className="section-title mb-4 pb-2">
                              <h4 className="title mb-4">Testimonials</h4>
                              <p className="text-muted para-desc mx-auto mb-0">What our customers say about us</p>
                          </div>
                      </div>
                  </div>
        
                  <div className="row justify-content-center">
                      <div className="col-md-10 mt-4 pt-2">
                          <ClientThree/>
                      </div>
                  </div>
              </div>
 

      <div className="container mt-4">
          <div className="bg-dark bg-cta-dark rounded p-md-5 p-4 p-sm-0 shadow">
              <div className="row align-items-center">
                  <div className="col-sm-7">
                      <div className="text-sm-start">
                          <h4 className="text-white title-dark">Ready to grow with India?</h4>
                          <p className="text-white-50 para-desc para-dark mb-0"></p>
                      </div>
                  </div>

                  <div className="col-sm-5 mt-4 mt-sm-0">
                      <div className="text-sm-end">
                          <Link to="/contact" className="btn btn-primary"><i className="mdi mdi-phone-outline"></i> Let's talk</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Footer/>
    </>
  )
}
